async function updateCartStatus() {
    const cart = await fetch("/cart.js").then((r) => r.json());
    const restrictedProductIds = [
        42037384282183,
        42037511651399,
        42037573255239,
        42349514293319,
        42349514358855,
        42349514326087,
    ];
    const hasMembershipProduct = cart.items.filter(
      (item) => restrictedProductIds.includes(item.id)
    ).length > 0;
    // A customer can checkout if they have at least one non-membership item
    const canCheckout = cart.items.filter(
      (item) => !restrictedProductIds.includes(item.id)
    ).length;

    if(hasMembershipProduct && document.querySelector(".membership__upsell")){
        document.querySelector(".membership__upsell").style.display = "none";
      }

    if (!canCheckout) {
      // Disable checkout button
      document
        .querySelectorAll('button[name="checkout"]')
        .forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
          btn.style.opacity = "0.5";
          btn.style.pointerEvents = "none";
          btn.parentElement.innerHTML =
        `<p style='color:red; font-size: 12px; text-align: center;'>These products cannot be purchased on its own. Please add another item to proceed.</p>${btn.outerHTML}`;
        });

      // Show warning
      const drawer = document.querySelector(".drawer__foot");
      if (drawer && drawer.querySelector(".warning-message")) {
        drawer.querySelector(".warning-message").innerText =
          "This product cannot be purchased on its own. Please add another item to proceed.";
      }
    } else {
      // Enable checkout button
      document
        .querySelectorAll('button[name="checkout"]')
        .forEach((btn) => {
          btn.removeAttribute("disabled");
          btn.style.opacity = "1";
          btn.style.pointerEvents = "auto";
          btn.parentElement.innerHTML =btn.outerHTML;
        });

      // Remove warning
      const drawer = document.querySelector(".drawer__foot");
      if (drawer && drawer.querySelector(".warning-message")) {
        drawer.querySelector(".warning-message").innerText = "";
      }
    }
  }

updateCartStatus();
document.addEventListener("theme:cart:change", updateCartStatus);